<template>
  <div class="node-props">
    <div class="props-header">
      <span>节点属性</span>
      <button class="props-close" @click="$emit('close')" title="关闭">&times;</button>
    </div>
    <div class="props-body" v-if="node">

      <!-- ==================== 开始节点 type=0 ==================== -->
      <template v-if="node.nodeType === 0">
        <!-- 基本信息 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row full"><label>处理描述</label><textarea v-model="node.props.remarkField" @input="save" class="prop-input" rows="3" placeholder="操作的描述信息..." /></div>
        </details>

        <!-- 表单设置 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-file-alt"></i> 表单设置</summary>
          <div class="prop-row"><label>处理表单</label>
            <select v-model="node.props.approvelForm" @change="save" class="prop-input">
              <option value="">-- 请选择流程表单 --</option>
              <option v-for="f in flowForms" :key="f.guid" :value="f.name">{{ f.name }}</option>
            </select>
          </div>
          <div class="prop-row"><label>移动端表单</label>
            <select v-model="node.props.customForm" @change="save" class="prop-input">
              <option value="">-- 请选择移动表单 --</option>
              <option v-for="f in flowForms" :key="'m'+f.guid" :value="f.name">{{ f.name }}</option>
            </select>
          </div>
          <div class="prop-row"><label>打印表单</label>
            <select v-model="node.props.approvelPrintForm" @change="save" class="prop-input">
              <option value="">-- 请选择打印模版 --</option>
              <option v-for="f in flowForms" :key="'pf'+f.guid" :value="f.name">{{ f.name }}</option>
              <optgroup label="系统模版">
                <option value="default">系统默认模版</option>
                <option value="detail">明细模版</option>
                <option value="summary">汇总模版</option>
              </optgroup>
            </select>
          </div>
          <div class="prop-row"><label>本地打印</label><input v-model="node.props.localPrintForm" @input="save" class="prop-input" placeholder="本地上传打印模版路径" /></div>
          <div class="prop-row"><label>保存按钮</label><input type="checkbox" v-model="node.props.useSave" @change="save" class="prop-check" /></div>
          <div class="prop-row"><label>快照功能</label><input type="checkbox" v-model="node.props.snapshot" @change="save" class="prop-check" /></div>
          <div class="prop-row full"><label>操作文档</label>
            <div class="file-upload-row">
              <input ref="fileInput" type="file" @change="onFileSelect" class="file-input" />
              <button type="button" class="btn-upload" @click="triggerFileSelect">选择文件</button>
              <span class="file-name" v-if="node.props.operateDoc">{{ node.props.operateDocName || node.props.operateDoc }}</span>
            </div>
          </div>
        </details>

        <!-- 默认新任务通知 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-bell"></i> 默认新任务通知</summary>
          <div class="prop-row full"><label>通知方式</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="startNotifyChecked(0)" @change="startNotifyToggle(0)" /> Mail通知</label>
              <label class="cb-label"><input type="checkbox" :checked="startNotifyChecked(1)" @change="startNotifyToggle(1)" /> QQ通知</label>
              <label class="cb-label"><input type="checkbox" :checked="startNotifyChecked(2)" @change="startNotifyToggle(2)" /> 钉钉通知</label>
              <label class="cb-label"><input type="checkbox" :checked="startNotifyChecked(3)" @change="startNotifyToggle(3)" /> 微信通知</label>
            </div>
          </div>
        </details>

        <!-- 附件 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-paperclip"></i> 附件</summary>
          <div class="prop-row full"><label>附件权限</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="attCheckedAll(3)" @change="attToggleAll(3)" /> 全选</label>
              <label class="cb-label"><input type="checkbox" :checked="attChecked(0)" @change="attToggle(0)" /> 查看</label>
              <label class="cb-label"><input type="checkbox" :checked="attChecked(1)" @change="attToggle(1)" /> 添加</label>
              <label class="cb-label"><input type="checkbox" :checked="attChecked(2)" @change="attToggle(2)" /> 删除</label>
            </div>
          </div>
          <div class="prop-row full"><label>附件类型</label>
            <div class="radio-group">
              <label class="radio-label"><input type="radio" :checked="ps('attachmentType','0')==='0'" @change="setPs('attachmentType','0')" /> 不受限制</label>
              <label class="radio-label"><input type="radio" :checked="ps('attachmentType','0')==='1'" @change="setPs('attachmentType','1')" /> 仅可添加</label>
              <label class="radio-label"><input type="radio" :checked="ps('attachmentType','0')==='2'" @change="setPs('attachmentType','2')" /> 排除</label>
            </div>
            <input v-if="ps('attachmentType')==='2'" v-model="node.props.attachmentExt" @input="save" class="prop-input" placeholder="扩展名,如: exe,bat" style="margin-top:4px" />
          </div>
          <div class="prop-row full"><label>附件大小</label>
            <div class="radio-group">
              <label class="radio-label"><input type="radio" :checked="ps('attachmentSizeType','0')==='0'" @change="setPs('attachmentSizeType','0')" /> 不受限制</label>
              <label class="radio-label"><input type="radio" :checked="ps('attachmentSizeType','0')==='1'" @change="setPs('attachmentSizeType','1')" /> 单文件设限</label>
              <label class="radio-label"><input type="radio" :checked="ps('attachmentSizeType','0')==='2'" @change="setPs('attachmentSizeType','2')" /> 总文件设限</label>
            </div>
            <span v-if="ps('attachmentSizeType')!=='0'" style="display:flex;align-items:center;gap:4px;margin-top:4px"><input v-model="node.props.attachmentSize" @input="save" class="prop-input" placeholder="大小限制" type="number" style="flex:1" /><span style="font-size:12px;color:#9ca3af">MB</span></span>
          </div>
          <div class="prop-row"><label>意见必填</label><input type="checkbox" :checked="ps('opinionPerm','0')==='1'" @change="setPs('opinionPerm', ($event.target.checked ? '1' : '0'))" class="prop-check" /></div>
          <div class="prop-row"><label>合并分流</label><input type="checkbox" :checked="ps('mergerType')==='1'" @change="setPs('mergerType', ($event.target.checked ? '1' : '0'))" class="prop-check" /><span style="font-size:11px;color:#9ca3af;margin-left:4px">多分支汇合控制</span></div>
          <template v-if="ps('mergerType')==='1'">
            <div style="margin:4px 14px">
              <div style="font-weight:600;color:#065f46;font-size:12px;margin-bottom:4px">合并连线配置</div>
              <table class="simple-table">
                <thead><tr><th>名称</th><th>连线ID</th><th>连线名称</th><th style="width:40px"></th></tr></thead>
                <tbody>
                  <tr v-for="(m, mi) in ensureMergerList()" :key="'mg'+mi">
                    <td><input v-model="node.props.mergerName[mi]" @input="save" class="prop-input" /></td>
                    <td><input v-model="node.props.mergerLinkId[mi]" @input="save" class="prop-input" /></td>
                    <td><input v-model="node.props.mergerLinkName[mi]" @input="save" class="prop-input" /></td>
                    <td><button class="table-remove-btn" @click="removeMergerItem(mi)">&times;</button></td>
                  </tr>
                  <tr v-if="ensureMergerList().length===0"><td colspan="4" style="color:#9ca3af;font-size:11px;text-align:center;padding:4px">暂无合并连线配置</td></tr>
                </tbody>
              </table>
              <button class="handler-add-btn" @click="addMergerItem" style="margin-left:0"><i class="fas fa-plus"></i> 添加合并连线</button>
            </div>
          </template>
        </details>

        <!-- 任务操作权限 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-shield-alt"></i> 任务操作权限</summary>
          <div class="prop-row full"><label>操作权限</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="startPermAllChecked()" @change="startPermToggleAll()" /> 全选</label>
              <label class="cb-label" v-for="(name,i) in ['取回','撤回','删除','公开','委托','调度','加签','询问','暂停','直送']" :key="'sop'+i">
                <input type="checkbox" :checked="startPermChecked(i)" @change="startPermToggle(i)" /> {{ name }}
              </label>
            </div>
          </div>
          <div class="prop-row" v-if="startPermChecked(0)"><label>取回规则</label>
            <select :value="ps('getTaskRule','01')" @change="e => setPs('getTaskRule', e.target.value)" class="prop-input">
              <option value="01">随时取回(任务未结束)</option>
              <option value="02">仅在下一步审批前取回</option>
            </select>
          </div>
        </details>

        <!-- 抄送人 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-users"></i> 抄送人</summary>
          <div class="handler-list">
            <div v-for="(cc, idx) in ensureCCList()" :key="idx" class="handler-row">
              <ParticipantEditor :model="cc" :node-options="handlerStepOptions" :on-change="save" :on-pick="(t) => openPersonSelector(cc, t)" />
              <button class="handler-remove" @click="removeCC(idx)" title="移除">&times;</button>
            </div>
          </div>
          <button class="handler-add-btn" @click="addCC"><i class="fas fa-plus"></i> 添加抄送人</button>
        </details>

        <!-- 自定义通知 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-envelope"></i> 自定义通知</summary>
          <div v-for="(msg, idx) in ensureCustomNotifyList()" :key="'cn'+idx" class="event-card">
            <div class="prop-row"><label>通知类型</label>
              <select v-model="msg.notifyType" @change="save" class="prop-input">
                <option value="mail">邮件</option>
                <option value="dingtalk">钉钉</option>
                <option value="wecom">企微</option>
                <option value="sms">短信</option>
              </select>
            </div>
            <div class="prop-row"><label>触发时机</label>
              <select v-model="msg.triggerOn" @change="save" class="prop-input">
                <option value="pending">待办时</option>
                <option value="done">已办时</option>
                <option value="end">结束时</option>
              </select>
            </div>
            <div class="prop-row"><label>标题</label><input v-model="msg.title" @input="save" class="prop-input" placeholder="通知标题" /></div>
            <div class="prop-row full"><label>内容</label><textarea v-model="msg.content" @input="save" class="prop-input" rows="2" placeholder="通知内容" /></div>
            <div class="prop-row"><label>接收人</label><input v-model="msg.receivers" @input="save" class="prop-input" placeholder="接收人账号，逗号分隔" /></div>
            <button class="handler-remove event-rm" @click="removeCustomNotify(idx)"><i class="fas fa-times"></i> 移除</button>
          </div>
          <button class="handler-add-btn" @click="addCustomNotify"><i class="fas fa-plus"></i> 添加通知</button>
        </details>

        <!-- 触发事件 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-bolt"></i> 触发事件</summary>
          <div v-for="(evt, idx) in ensureEventList()" :key="idx" class="event-card">
            <div class="event-card-row">
              <div class="event-card-col">
                <label>触发时机</label>
                <select v-model="evt.trigger" @change="save" class="prop-input">
                  <option value="afterSubmit">提交后执行</option>
                  <option value="afterSave">保存后执行</option>
                  <option value="afterRetrieve">取回后执行</option>
                  <option value="afterDelete">删除后执行</option>
                  <option value="afterEnd">结束后执行</option>
                </select>
              </div>
              <div class="event-card-col">
                <label>事件名称</label>
                <input v-model="evt.name" @input="save" class="prop-input" placeholder="事件名称" />
              </div>
              <div class="event-card-col">
                <label>执行方式</label>
                <select v-model="evt.executeType" @change="save" class="prop-input">
                  <option value="SQL">SQL</option>
                  <option value="WebApi">WebApi</option>
                </select>
              </div>
              <button class="handler-remove event-rm" @click="removeEvent(idx)"><i class="fas fa-times"></i></button>
            </div>
            <div class="prop-row" v-if="(evt.executeType||'SQL')==='SQL'" style="margin-top:4px"><label>数据源</label>
              <select v-model="evt.dataSource" @change="save" class="prop-input">
                <option value="Default">Default</option>
                <option v-for="ds in dataSourceList" :key="ds" :value="ds">{{ ds }}</option>
              </select>
            </div>
            <div class="prop-row full" style="margin-top:4px"><label>{{ (evt.executeType||'SQL')==='SQL' ? 'SQL语句' : 'API地址' }}</label>
              <textarea @focus="onTAFocus($event, 'event', idx)" v-model="evt.code" @input="save" class="prop-input code-input" rows="5" :placeholder="(evt.executeType||'SQL')==='SQL' ? '输入SQL语句...' : '输入WebApi地址...'" /></div>
            <div class="prop-row full">
              <label style="cursor:pointer;user-select:none" @click="toggleEventVars(idx)">流程变量 {{ evt._showVars ? '▾' : '▸' }}</label>
              <div class="var-panel" v-show="evt._showVars">
                <div class="var-section">
                  <div class="var-section-hd" @click="varFold.sys = !varFold.sys"><span class="var-arrow">{{ varFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ sysVariables.length }})</div>
                  <div class="var-tags" v-show="varFold.sys">
                    <button v-for="v in sysVariables" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
                <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                  <div class="var-section-hd" @click="toggleTableFold(tb.category)"><span class="var-arrow">{{ varFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                  <div class="var-tags var-tags-scroll" v-show="varFold.tables[tb.category]">
                    <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="handler-add-btn" @click="addEvent"><i class="fas fa-plus"></i> 添加事件</button>
        </details>
      </template>

      <!-- ==================== 审批节点 type=1 ==================== -->
      <template v-if="node.nodeType === 1">
        <!-- 基本信息 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row"><label>处理描述</label><textarea v-model="node.props.description" @input="save" class="prop-input" rows="2" placeholder="当前节点处理描述" /></div>
          <div class="prop-row"><label>标准处理时间(分钟)</label><input v-model="node.props.allowBat" @input="save" class="prop-input" placeholder="标准处理分钟数" /></div>
        </details>

        <!-- 表单设置 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-file-alt"></i> 表单设置</summary>
          <div class="prop-row"><label>绑定表单</label>
            <select v-model="node.props.approvelForm" @change="save" class="prop-input">
              <option value="">-- 请选择流程表单 --</option>
              <option v-for="f in flowForms" :key="f.guid" :value="f.name">{{ f.name }}</option>
            </select>
          </div>
          <div class="prop-row"><label>移动表单</label>
            <select v-model="node.props.customForm" @change="save" class="prop-input">
              <option value="">-- 请选择移动表单 --</option>
              <option v-for="f in flowForms" :key="'m'+f.guid" :value="f.name">{{ f.name }}</option>
            </select>
          </div>
          <div class="prop-row"><label>本地表单</label><input v-model="node.props.localPrintForm" @input="save" class="prop-input" placeholder="本地上传打印模版路径" /></div>
          <div class="prop-row"><label>系统打印模版</label>
            <select v-model="node.props.approvelPrintForm" @change="save" class="prop-input">
              <option value="">-- 请选择打印模版 --</option>
              <option v-for="f in flowForms" :key="'pf1'+f.guid" :value="f.name">{{ f.name }}</option>
              <optgroup label="系统模版">
                <option value="default">系统默认模版</option>
                <option value="detail">明细模版</option>
                <option value="summary">汇总模版</option>
              </optgroup>
            </select>
          </div>
          <div class="prop-row full"><label>操作文档</label>
            <div class="file-upload-row">
              <input ref="fileInput2" type="file" @change="onFileSelect" class="file-input" />
              <button type="button" class="btn-upload" @click="triggerFileSelect">选择文件</button>
              <span class="file-name" v-if="node.props.operateDoc">{{ node.props.operateDocName || node.props.operateDoc }}</span>
            </div>
          </div>
          <div class="prop-row"><label>显示保存</label><input type="checkbox" v-model="node.props.useSave" @change="save" class="prop-check" /></div>
          <div class="prop-row"><label>快照</label><input type="checkbox" v-model="node.props.snapshot" @change="save" class="prop-check" /></div>
        </details>

        <!-- 处理策略 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-cogs"></i> 处理策略</summary>
          <div class="prop-row full"><label>审批方式</label>
            <select :value="node.props.processingStrategy" @change="e => { node.props.processingStrategy = e.target.value; save() }" class="prop-input">
              <option value="1">抢先</option>
              <option value="2">抢先(自动代理)</option>
              <option value="3">共享</option>
              <option value="4">共享(首个提交)</option>
              <option value="5">全部同意(与)</option>
              <option value="6">全部同意(或)</option>
            </select>
          </div>
          <div class="prop-row full"><label>同意规则</label>
            <select :value="node.props.agreeType" @change="e => { node.props.agreeType = parseInt(e.target.value); save() }" class="prop-input">
              <option :value="0">不需要同意按钮</option>
              <option :value="1">必须点击同意</option>
              <option :value="2">条件式同意</option>
            </select>
          </div>
          <template v-if="node.props.agreeType >= 1">
            <div class="prop-row"><label>同意按钮</label><input v-model="node.props.agreeButton" @input="save" class="prop-input" placeholder="按钮文字" /></div>
          </template>
          <template v-if="node.props.agreeType == 2">
            <div class="prop-row full"><label>同意条件</label>
              <div class="cb-group">
                <label class="cb-label"><input type="checkbox" :checked="agreeRuleChecked(0)" @change="agreeRuleToggle(0)" /> 找不到处理人</label>
                <label class="cb-label"><input type="checkbox" :checked="agreeRuleChecked(1)" @change="agreeRuleToggle(1)" /> 与上一节点重复</label>
                <label class="cb-label"><input type="checkbox" :checked="agreeRuleChecked(2)" @change="agreeRuleToggle(2)" /> 已审批通过</label>
                <label class="cb-label"><input type="checkbox" :checked="agreeRuleChecked(3)" @change="agreeRuleToggle(3)" /> 与发起人重复</label>
              </div>
            </div>
          </template>
          <div class="prop-row"><label>退回归组</label><input v-model="node.props.nodeGroup" @input="save" class="prop-input" placeholder="返回组标识" /></div>
        </details>

        <!-- 处理人设置 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-user-check"></i> 处理人设置</summary>
          <div class="handler-list">
            <div v-for="(h, idx) in ensureHandlers()" :key="idx" class="handler-card">
              <div class="handler-card-head">
                <div class="handler-card-title">
                  <i class="fas fa-user-tag"></i>
                  <span class="handler-tag">{{ sourceTypeLabel(h.sourceType) }}</span>
                  <span class="handler-target" v-if="h.sourceType!=='submitter' && h.sourceType!=='field' && h.sourceType!=='step'">
                    {{ h.userName || h.orgName || h.roleName || '未选择' }}
                  </span>
                  <span class="handler-target" v-else-if="h.sourceType==='step'">{{ h.stepName || '未填写' }}</span>
                  <span class="handler-target" v-else-if="h.sourceType==='field'">{{ h.fieldName || '未填写' }}</span>
                  <span class="handler-target" v-else>—</span>
                </div>
                <button class="handler-card-remove" @click="removeHandler(idx)" title="移除该处理人">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>

              <div class="handler-card-body">
                <ParticipantEditor :model="h" :node-options="handlerStepOptions" :on-change="save" :on-pick="(t) => openPersonSelector(h, t)" />
                <div class="handler-field" v-if="h.sourceType!=='submitter' && h.sourceType!=='field' && h.sourceType!=='step' && h.sourceType!=='all_participant' && h.sourceType!=='everyone'">
                  <label class="handler-label">显示名称</label>
                  <select v-model="h.showName" @change="save" class="handler-control">
                    <option value="">原名</option>
                    <option value="name">姓名</option>
                    <option value="dept">部门</option>
                    <option value="position">岗位</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <button class="handler-add-btn" @click="addHandler">
            <i class="fas fa-plus-circle"></i> 添加处理人
          </button>
        </details>

        <!-- 任务操作权限 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-shield-alt"></i> 任务操作权限</summary>
          <div class="prop-row full"><label>操作权限</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" @change="approvelPermToggleAll()" :checked="ensureApprovelPerm().split('').every(c=>c==='1')" /> 全选</label>
              <label class="cb-label" v-for="(name,i) in approvelPermNames" :key="'ap'+i"><input type="checkbox" :checked="approvelPermChecked(i)" @change="approvelPermToggle(i)" /> {{ name }}</label>
            </div>
          </div>
          <div class="prop-row"><label>取回规则</label>
            <select :value="node.props.retrieveRule" @change="e => { node.props.retrieveRule = e.target.value; save() }" class="prop-input">
              <option value="always">始终可取回</option>
              <option value="beforeNext">仅下一步前可取回</option>
            </select>
          </div>
          <div class="prop-row"><label>获取规则</label>
            <select :value="node.props.getTaskRule" @change="e => { node.props.getTaskRule = e.target.value; save() }" class="prop-input">
              <option value="01">先到先得</option>
              <option value="02">共享任务</option>
            </select>
          </div>
        </details>

        <!-- 附件设置 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-paperclip"></i> 附件设置</summary>
          <div class="prop-row full"><label>附件权限</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="attChecked(0)" @change="attToggle(0)" /> 查看</label>
              <label class="cb-label"><input type="checkbox" :checked="attChecked(1)" @change="attToggle(1)" /> 上传</label>
              <label class="cb-label"><input type="checkbox" :checked="attChecked(2)" @change="attToggle(2)" /> 删除</label>
            </div>
          </div>
          <div class="prop-row"><label>单附件权限</label><input type="checkbox" v-model="node.props.attachmentSinglePerm" @change="save" class="prop-check" /></div>
          <div class="prop-row"><label>附件类型限制</label><input v-model="node.props.attachmentTypeLimit" @input="save" class="prop-input" placeholder="如: .pdf,.doc,.xls" /></div>
          <div class="prop-row"><label>附件大小限制(KB)</label><input v-model="node.props.attachmentSizeLimit" @input="save" class="prop-input" placeholder="最大附件大小" /></div>
        </details>

        <!-- 更多设置 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-sliders-h"></i> 更多设置</summary>
          <div class="prop-row"><label>必须填写意见</label><input type="checkbox" v-model="node.props.needRemark" @change="save" class="prop-check" /></div>
        </details>

        <!-- 任务通知 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-bell"></i> 任务通知</summary>
          <div class="prop-row full"><label>通知渠道</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="notifyChannelChecked('mail')" @change="notifyChannelToggle('mail')" /> Mail通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChannelChecked('dingtalk')" @change="notifyChannelToggle('dingtalk')" /> 钉钉通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChannelChecked('wecom')" @change="notifyChannelToggle('wecom')" /> 微信通知</label>
            </div>
          </div>
          <div class="prop-row full"><label>通知时机</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="notifyChecked(0)" @change="notifyToggle(0)" /> 撤回通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChecked(1)" @change="notifyToggle(1)" /> 拒绝通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChecked(2)" @change="notifyToggle(2)" /> 退回通知</label>
            </div>
          </div>
          <div class="prop-row full"><label>通知模版</label>
            <select :value="node.props.notifyTemplateType" @change="e => { node.props.notifyTemplateType = e.target.value; save() }" class="prop-input">
              <option value="default">系统默认模版</option>
              <option value="custom">自定义模版</option>
            </select>
          </div>
          <template v-if="node.props.notifyTemplateType === 'custom'">
            <div class="prop-row full"><label>模版标题</label><input v-model="node.props.notifyTemplateTitle" @input="save" class="prop-input" placeholder="通知标题" /></div>
            <div class="prop-row full"><label>模版内容</label><textarea v-model="node.props.notifyTemplateContent" @input="save" class="prop-input" rows="3" placeholder="通知内容（支持变量）" /></div>
          </template>
        </details>

        <!-- 抄送人 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-users"></i> 抄送人</summary>
          <div class="handler-list">
            <div v-for="(cc, idx) in ensureCCList()" :key="idx" class="handler-row">
              <div class="handler-row">
                <select v-model="cc.sourceType" @change="save" class="handler-type">
                  <option value="submitter">提交人</option>
                  <option value="user">用户</option>
                  <option value="org">组织</option>
                  <option value="role">角色</option>
                  <option value="step">某步处理人</option>
                  <option value="field">表单字段</option>
                </select>
                <template v-if="cc.sourceType==='user'">
                  <div class="handler-value selected-name" :class="{ placeholder: !cc.userName }" @click="openPersonSelector(cc, 'user')">
                    <span class="sel-name-text">{{ cc.userName || '点击选择用户' }}</span>
                    <span class="sel-code-text" v-if="cc.userCode">{{ cc.userCode }}</span>
                  </div>
                </template>
                <template v-if="cc.sourceType==='org'">
                  <div class="handler-value selected-name" :class="{ placeholder: !cc.orgName }" @click="openPersonSelector(cc, 'org')">
                    <span class="sel-name-text">{{ cc.orgName || '点击选择组织' }}</span>
                    <span class="sel-code-text" v-if="cc.orgCode">{{ cc.orgCode }}</span>
                  </div>
                </template>
                <template v-if="cc.sourceType==='role'">
                  <div class="handler-value selected-name" :class="{ placeholder: !cc.roleName }" @click="openPersonSelector(cc, 'role')">
                    <span class="sel-name-text">{{ cc.roleName || '点击选择角色' }}</span>
                    <span class="sel-code-text" v-if="cc.roleCode">{{ cc.roleCode }}</span>
                  </div>
                </template>
                <input v-if="cc.sourceType==='step'" v-model="cc.stepName" @input="save" class="handler-value" placeholder="步骤名称" />
                <input v-if="cc.sourceType==='field'" v-model="cc.fieldName" @input="save" class="handler-value" placeholder="表单字段名" />
              </div>
              <div class="handler-row" style="margin-top:2px">
                <label style="display:flex;align-items:center;gap:4px;font-size:12px;white-space:nowrap">
                  <input type="checkbox" v-model="cc.relation.enabled" @change="save" /> 启用关系
                </label>
                <template v-if="cc.relation.enabled">
                  <select v-model="cc.relation.type" @change="save" class="handler-type">
                    <option value="superior">上级部门</option>
                    <option value="direct_leader">直接领导</option>
                    <option value="all_leaders">所有领导</option>
                    <option value="position_leader">某职位领导</option>
                    <option value="rank_leader">某职级领导</option>
                    <option value="skip_rank">按职级跳过</option>
                  </select>
                  <input v-if="cc.relation.type==='position_leader'" v-model="cc.relation.positionName" @input="save" class="handler-value" placeholder="职位名称" />
                  <input v-if="cc.relation.type==='rank_leader'" v-model.number="cc.relation.rankLevel" @input="save" class="handler-value-sm" type="number" min="1" placeholder="职级" />
                  <input v-if="cc.relation.type==='skip_rank'" v-model.number="cc.relation.skipCount" @input="save" class="handler-value-sm" type="number" min="1" placeholder="跳过级数" />
                </template>
              </div>
              <button class="handler-remove" @click="removeCC(idx)" title="移除">&times;</button>
            </div>
          </div>
          <button class="handler-add-btn" @click="addCC"><i class="fas fa-plus"></i> 添加抄送人</button>
        </details>

        <!-- 超时设置 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-clock"></i> 超时处理策略</summary>
          <div class="prop-row full"><label>超时类型</label>
            <select :value="getTimeoutField('timeoutType')" @change="e => { setNodeProp('timeoutType', e.target.value); save() }" class="prop-input">
              <option value="">不限时</option>
              <option value="1">指定时长</option>
              <option value="2">指定截止</option>
              <option value="3">表单字段</option>
              <option value="4">工作日</option>
            </select>
          </div>
          <template v-if="node.props.timeoutType">
            <div class="prop-row"><label>超时值</label><input v-model="node.props.timeoutValue" @input="save" class="prop-input" :placeholder="node.props.timeoutType === '3' ? '表单字段名' : '数值'" /></div>
          </template>
          <div class="prop-row full"><label>超时日历</label>
            <select :value="getTimeoutField('timeoutCalendarType')" @change="e => { setNodeProp('timeoutCalendarType', e.target.value); save() }" class="prop-input">
              <option value="">标准日历</option>
              <option value="1">工作日历</option>
              <option value="2">指定日历</option>
            </select>
          </div>
          <template v-if="getTimeoutField('timeoutCalendarType') === '2'">
            <div class="prop-row"><label>日历ID</label><input v-model="node.props.timeoutCalendarId" @input="save" class="prop-input" placeholder="指定日历ID" /></div>
          </template>
          <div class="prop-row full"><label>超时处理</label>
            <select :value="getTimeoutField('timeoutProcessType')" @change="e => { setNodeProp('timeoutProcessType', e.target.value); save() }" class="prop-input">
              <option value="">不处理</option>
              <option value="1">自动通过</option>
              <option value="2">自动转办</option>
            </select>
          </div>
          <template v-if="getTimeoutField('timeoutProcessType') === '2'">
            <div class="prop-row"><label>转办目标</label><input v-model="node.props.timeoutTarget" @input="save" class="prop-input" placeholder="转办目标节点ID" /></div>
          </template>
        </details>

        <!-- 自定义通知 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-envelope"></i> 自定义通知</summary>
          <div class="handler-list">
            <div v-for="(msg, idx) in ensureCustomNotifyList()" :key="idx" class="handler-card">
              <div class="prop-row"><label>通知类型</label>
                <select v-model="msg.notifyType" @change="save" class="prop-input">
                  <option value="mail">邮件</option>
                  <option value="dingtalk">钉钉</option>
                  <option value="wecom">企微</option>
                  <option value="sms">短信</option>
                </select>
              </div>
              <div class="prop-row"><label>触发时机</label>
                <select v-model="msg.triggerOn" @change="save" class="prop-input">
                  <option value="pending">待办时</option>
                  <option value="done">已办时</option>
                  <option value="finished">办结时</option>
                  <option value="reject">拒绝时</option>
                  <option value="return">退回时</option>
                  <option value="timeout">超时时</option>
                </select>
              </div>
              <div class="prop-row"><label>标题</label><input v-model="msg.title" @input="save" class="prop-input" placeholder="通知标题" /></div>
              <div class="prop-row full"><label>内容</label><textarea v-model="msg.content" @input="save" class="prop-input" rows="2" placeholder="通知内容(支持变量)" /></div>
              <!-- 接收人：使用统一的参与者编辑器（10 种类型 + 关系/筛选） -->
              <div class="prop-row full"><label>接收人</label>
                <ParticipantEditor :model="msg" :node-options="handlerStepOptions" :on-change="save" :on-pick="(t) => openPersonSelector(msg, t)" />
              </div>
              <button class="handler-remove event-rm" @click="removeCustomNotify(idx)"><i class="fas fa-times"></i> 移除</button>
            </div>
          </div>
          <button class="handler-add-btn" @click="addCustomNotify"><i class="fas fa-plus"></i> 添加自定义通知</button>
        </details>

        <!-- 触发事件 -->
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-bolt"></i> 触发事件</summary>
          <div v-for="(evt, idx) in ensureEventList()" :key="idx" class="event-card">
            <div class="event-card-row">
              <div class="event-card-col">
                <label>触发时机</label>
                <select v-model="evt.trigger" @change="save" class="prop-input">
                  <option value="afterAgree">同意后执行</option>
                  <option value="afterReject">拒绝后执行</option>
                  <option value="afterRetrieve">取回后执行</option>
                  <option value="afterDelete">删除后执行</option>
                  <option value="afterTimeout">超时后执行</option>
                  <option value="afterAddSign">加签后执行</option>
                  <option value="afterTransfer">转办后执行</option>
                </select>
              </div>
              <div class="event-card-col">
                <label>事件名称</label>
                <input v-model="evt.name" @input="save" class="prop-input" placeholder="事件名称" />
              </div>
              <div class="event-card-col">
                <label>执行方式</label>
                <select v-model="evt.executeType" @change="save" class="prop-input">
                  <option value="SQL">SQL</option>
                  <option value="WebApi">WebApi</option>
                </select>
              </div>
              <button class="handler-remove event-rm" @click="removeEvent(idx)"><i class="fas fa-times"></i></button>
            </div>
            <div class="prop-row" v-if="(evt.executeType||'SQL')==='SQL'" style="margin-top:4px"><label>数据源</label>
              <select v-model="evt.dataSource" @change="save" class="prop-input">
                <option value="Default">Default</option>
                <option v-for="ds in dataSourceList" :key="ds" :value="ds">{{ ds }}</option>
              </select>
            </div>
            <div class="prop-row full" style="margin-top:4px"><label>{{ (evt.executeType||'SQL')==='SQL' ? 'SQL语句' : 'API地址' }}</label>
              <textarea @focus="onTAFocus($event, 'event', idx)" v-model="evt.code" @input="save" class="prop-input code-input" rows="5" :placeholder="(evt.executeType||'SQL')==='SQL' ? '输入SQL语句...' : '输入WebApi地址...'" /></div>
            <div class="prop-row full">
              <label style="cursor:pointer;user-select:none" @click="toggleEventVars(idx)">流程变量 {{ evt._showVars ? '▾' : '▸' }}</label>
              <div class="var-panel" v-show="evt._showVars">
                <div class="var-section">
                  <div class="var-section-hd" @click="varFold.sys = !varFold.sys"><span class="var-arrow">{{ varFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ sysVariables.length }})</div>
                  <div class="var-tags" v-show="varFold.sys">
                    <button v-for="v in sysVariables" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
                <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                  <div class="var-section-hd" @click="toggleTableFold(tb.category)"><span class="var-arrow">{{ varFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                  <div class="var-tags var-tags-scroll" v-show="varFold.tables[tb.category]">
                    <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="handler-add-btn" @click="addEvent"><i class="fas fa-plus"></i> 添加事件</button>
        </details>

      </template>


      <!-- ======= 以下节点类型保持不变 ======= -->

      <!-- ======= 决策节点 type=2 ======= -->
      <template v-if="node.nodeType === 2">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row"><label>决策权限</label><input v-model="node.props.approvelTaskPermit" @input="save" class="prop-input" placeholder="权限表达式" /></div>
        </details>
        <details class="prop-group">
          <summary class="group-title"><i class="fas fa-bell"></i> 任务通知</summary>
          <div class="prop-row full"><label>通知设置</label><input v-model="node.props.taskNotify" @input="save" class="prop-input" placeholder="通知表达式" /></div>
        </details>
      </template>

      <!-- ======= 条件节点 type=3 ======= -->
      <template v-if="node.nodeType === 3">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
        </details>
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-code-branch"></i> 条件来源</summary>
          <div class="prop-row"><label>表单字段</label><input type="checkbox" :checked="condTypeChecked(0)" @change="condTypeToggle(0)" class="prop-check" /></div>
          <div class="prop-row"><label>SQL语句</label><input type="checkbox" :checked="condTypeChecked(1)" @change="condTypeToggle(1)" class="prop-check" /></div>
          <div class="prop-row"><label>发起人</label><input type="checkbox" :checked="condTypeChecked(3)" @change="condTypeToggle(3)" class="prop-check" /></div>
        </details>
        <!-- 表单字段条件 -->
        <details class="prop-group" open v-if="condTypeChecked(0)">
          <summary class="group-title"><i class="fas fa-table"></i> 表单字段条件</summary>
          <div class="cond-rules">
            <div v-for="(rule, idx) in ensureCondRules()" :key="'cr'+idx" class="cond-rule-row">
              <div v-if="idx>0" class="cond-logic">
                <select v-model="rule.logic" @change="save" class="cond-logic-sel">
                  <option value="AND">且</option>
                  <option value="OR">或</option>
                </select>
              </div>
              <div class="cond-fields">
                <select v-model="rule.tableName" @change="onCondTableChange(rule)" class="cond-sel">
                  <option value="">-- 主表 --</option>
                  <option v-for="tb in tableGroupOptions" :key="tb.name" :value="tb.name">{{ tb.name }}</option>
                </select>
                <select v-model="rule.fieldName" @change="save" class="cond-sel">
                  <option value="">-- 字段 --</option>
                  <option v-for="f in getCondFields(rule.tableName)" :key="f.value" :value="f.value">{{ f.label }}</option>
                </select>
                <select v-model="rule.operator" @change="save" class="cond-op">
                  <option v-for="op in condOperators" :key="op.value" :value="op.value">{{ op.label }}</option>
                </select>
                <input v-if="!isNullOp(rule.operator)" v-model="rule.value" @input="save" class="cond-val" placeholder="值" />
                <button class="cond-rm" @click="removeCondRule(idx)">×</button>
              </div>
            </div>
            <div v-if="ensureCondRules().length===0" style="color:#9ca3af;font-size:11px;text-align:center;padding:8px">暂无条件，点击下方按钮添加</div>
          </div>
          <button class="handler-add-btn" @click="addCondRule"><i class="fas fa-plus"></i> 添加条件</button>
        </details>
        <!-- SQL条件 -->
        <details class="prop-group" open v-if="condTypeChecked(1)">
          <summary class="group-title"><i class="fas fa-database"></i> SQL条件</summary>
          <div class="prop-row full"><label>SQL条件语句</label>
            <textarea @focus="onTAFocus($event, 'sqlCode')" v-model="node.props.sqlCode" @input="save" class="prop-input code-input" rows="6" placeholder="输入SQL条件语句，如: EXISTS(SELECT 1 FROM Table WHERE Field = @Field)" />
          </div>
          <div class="prop-row full">
            <label style="cursor:pointer;user-select:none" @click="showCondSqlVars = !showCondSqlVars">流程变量 {{ showCondSqlVars ? '▾' : '▸' }}</label>
            <div class="var-panel" v-show="showCondSqlVars">
              <div class="var-section">
                <div class="var-section-hd" @click="varFold.sys = !varFold.sys"><span class="var-arrow">{{ varFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ sysVariables.length }})</div>
                <div class="var-tags" v-show="varFold.sys">
                  <button v-for="v in sysVariables" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
              <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                <div class="var-section-hd" @click="toggleTableFold(tb.category)"><span class="var-arrow">{{ varFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                <div class="var-tags var-tags-scroll" v-show="varFold.tables[tb.category]">
                  <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
            </div>
          </div>
        </details>
        <!-- 发起人条件 -->
        <details class="prop-group" open v-if="condTypeChecked(3)">
          <summary class="group-title"><i class="fas fa-user"></i> 发起人条件</summary>
          <div class="cond-rules">
            <div v-for="(rule, idx) in ensureInitRules()" :key="'ir'+idx" class="cond-rule-row">
              <div v-if="idx>0" class="cond-logic">
                <select v-model="rule.logic" @change="save" class="cond-logic-sel">
                  <option value="AND">且</option>
                  <option value="OR">或</option>
                </select>
              </div>
              <div class="cond-fields">
                <select v-model="rule.field" @change="save" class="cond-sel">
                  <option value="">-- 发起人信息 --</option>
                  <option v-for="opt in initiatorFieldOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                </select>
                <select v-model="rule.operator" @change="save" class="cond-op">
                  <option v-for="op in initOperators" :key="op.value" :value="op.value">{{ op.label }}</option>
                </select>
                <input v-if="!isNullOp(rule.operator)" v-model="rule.value" @input="save" class="cond-val" placeholder="值" />
                <button class="cond-rm" @click="removeInitRule(idx)">×</button>
              </div>
            </div>
            <div v-if="ensureInitRules().length===0" style="color:#9ca3af;font-size:11px;text-align:center;padding:8px">暂无条件，点击下方按钮添加</div>
          </div>
          <button class="handler-add-btn" @click="addInitRule"><i class="fas fa-plus"></i> 添加条件</button>
        </details>
      </template>

      <!-- ======= 分流节点 type=4 ======= -->
      <template v-if="node.nodeType === 4">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
        </details>
      </template>

      <!-- ======= 合流节点 type=5 ======= -->
      <template v-if="node.nodeType === 5">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
        </details>
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-compress-arrows-alt"></i> 合流设置</summary>
          <div class="prop-row full"><label>关联分流</label>
            <select :value="node.props.splitSourceId || ''" @change="e => { node.props.splitSourceId = e.target.value; save() }" class="prop-input">
              <option value="">-- 自动匹配 --</option>
              <option v-for="s in ancestorSplits" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>合流类型</label>
            <select :value="node.props.unionType" @change="e => { node.props.unionType = parseInt(e.target.value); save() }" class="prop-input">
              <option :value="0">等待所有</option>
              <option :value="1">任一到即合</option>
            </select>
          </div>
        </details>
      </template>

      <!-- ======= 通知节点 type=6 ======= -->
      <template v-if="node.nodeType === 6">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row full"><label>通知描述</label><textarea v-model="node.props.description" @input="save" class="prop-input" rows="2" placeholder="通知描述" /></div>
        </details>
        <!-- 通知渠道 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-bell"></i> 通知渠道</summary>
          <div class="prop-row full"><label>通知方式</label>
            <div class="cb-group">
              <label class="cb-label"><input type="checkbox" :checked="notifyChChecked(0)" @change="notifyChToggle(0)" /> Mail通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChChecked(1)" @change="notifyChToggle(1)" /> QQ通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChChecked(2)" @change="notifyChToggle(2)" /> 钉钉通知</label>
              <label class="cb-label"><input type="checkbox" :checked="notifyChChecked(3)" @change="notifyChToggle(3)" /> 微信通知</label>
            </div>
          </div>
        </details>
        <!-- 收件人 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-users"></i> 收件人</summary>
          <div class="handler-list">
            <div v-for="(r, idx) in ensureReceiverList()" :key="'rcv'+idx" class="handler-row">
              <ParticipantEditor :model="r" :node-options="handlerStepOptions" :on-change="save" :on-pick="(t) => openPersonSelector(r, t)" />
              <button class="handler-remove" @click="removeReceiver(idx)" title="移除">&times;</button>
            </div>
          </div>
          <button class="handler-add-btn" @click="addReceiver"><i class="fas fa-plus"></i> 添加收件人</button>
        </details>
        <!-- 自定义通知模版 -->
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-envelope"></i> 自定义通知模版</summary>
          <div v-for="(msg, idx) in ensureCustomNotifyList()" :key="'nt'+idx" class="event-card">
            <div class="event-card-row">
              <div class="event-card-col">
                <label>通知类型</label>
                <select v-model="msg.notifyType" @change="save" class="prop-input">
                  <option value="mail">邮件</option>
                  <option value="dingtalk">钉钉</option>
                  <option value="wecom">企微</option>
                  <option value="sms">短信</option>
                </select>
              </div>
              <div class="event-card-col">
                <label>消息名称</label>
                <input v-model="msg.msgName" @input="save" class="prop-input" placeholder="新任务通知" />
              </div>
              <button class="handler-remove event-rm" @click="removeCustomNotify(idx)"><i class="fas fa-times"></i></button>
            </div>
            <div class="prop-row"><label>标题</label><input v-model="msg.title" @input="save" class="prop-input" placeholder="通知标题" /></div>
            <div class="prop-row full" style="margin-bottom:2px">
              <label>内容</label>
              <div class="editor-toolbar">
                <select @change="insertNotifyTag({type:'FONTSIZE', value: $event.target.value}, idx)" class="toolbar-fontsize">
                  <option value="">字号</option>
                  <option value="1">小</option>
                  <option value="3">中</option>
                  <option value="5">大</option>
                </select>
                <button type="button" @click="insertNotifyTag({type:'COLOR',value:'#000000'}, idx)" class="toolbar-btn" title="黑色">A</button>
                <button type="button" @click="insertNotifyTag({type:'COLOR',value:'#ef4444'}, idx)" class="toolbar-btn" title="红色" style="color:#ef4444">A</button>
                <button type="button" @click="insertNotifyTag({type:'COLOR',value:'#3b82f6'}, idx)" class="toolbar-btn" title="蓝色" style="color:#3b82f6">A</button>
                <button type="button" @click="insertNotifyTag({type:'B'}, idx)" class="toolbar-btn" title="加粗"><b>B</b></button>
                <button type="button" @click="insertNotifyTag({type:'I'}, idx)" class="toolbar-btn" title="斜体"><i>I</i></button>
                <button type="button" @click="insertNotifyTag({type:'TABLE'}, idx)" class="toolbar-btn" title="插入简单表格">▦</button>
              </div>
            </div>
            <div class="prop-row full">
              <textarea :data-notify-ta="idx" @focus="onNotifyTAFocus(idx)" v-model="msg.content" @input="save" class="prop-input code-input" rows="8" placeholder="输入通知内容，支持HTML格式。可使用上方工具栏插入样式和表格。" />
            </div>
            <!-- 流程变量 -->
            <div class="prop-row full">
              <label style="cursor:pointer;user-select:none" @click="toggleNotifyVars(idx)">流程变量 {{ msg._showVars ? '▾' : '▸' }}</label>
              <div class="var-panel" v-show="msg._showVars">
                <div class="var-section">
                  <div class="var-section-hd" @click="notifyVarFold.sys = !notifyVarFold.sys"><span class="var-arrow">{{ notifyVarFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ notifySysVariables.length }})</div>
                  <div class="var-tags" v-show="notifyVarFold.sys">
                    <button v-for="v in notifySysVariables" :key="v.value" class="var-tag" @click="insertNotifyVar(idx, v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
                <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                  <div class="var-section-hd" @click="toggleNotifyTableFold(tb.category)"><span class="var-arrow">{{ notifyVarFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                  <div class="var-tags var-tags-scroll" v-show="notifyVarFold.tables[tb.category]">
                    <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertNotifyVar(idx, v.value)" :title="v.desc">{{ v.label }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="handler-add-btn" @click="addCustomNotify"><i class="fas fa-plus"></i> 添加通知模版</button>
        </details>
      </template>

      <!-- ======= 快照节点 type=7 ======= -->
      <template v-if="node.nodeType === 7">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row"><label>描述</label><textarea v-model="node.props.description" @input="save" class="prop-input" rows="2" placeholder="快照描述" /></div>
        </details>
      </template>

      <!-- ======= 结束节点 type=8 ======= -->
      <template v-if="node.nodeType === 8">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-stop-circle"></i> 结束设置</summary>
          <div class="prop-row full"><label>结束类型</label>
            <select :value="node.props.endType" @change="e => { node.props.endType = e.target.value; save() }" class="prop-input">
              <option value="">承认结束</option>
              <option value="1">拒绝结束</option>
            </select>
          </div>
        </details>
      </template>

      <!-- ======= 子流程节点 type=35 ======= -->
      <template v-if="node.nodeType === 35">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
          <div class="prop-row"><label>调用方式</label>
            <select :value="node.props.callType || 'sync'" @change="e => { node.props.callType = e.target.value; save() }" class="prop-input">
              <option value="sync">同步（等待子流程结束）</option>
              <option value="async">异步（不等待）</option>
            </select>
          </div>
        </details>

        <SubFlowConfigPanel v-model:config="node.props.subFlow" @save="save" />
      </template>

      <!-- ======= SQL插件节点 type=42 ======= -->
      <template v-if="node.nodeType === 42">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
        </details>
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-database"></i> SQL插件设置</summary>
          <div class="prop-row"><label>数据源</label>
            <select v-model="node.props.dataSource" @change="save" class="prop-input">
              <option value="Default">Default</option>
              <option v-for="ds in dataSourceList" :key="ds" :value="ds">{{ ds }}</option>
            </select>
          </div>
          <div class="prop-row full"><label>SQL语句</label><textarea @focus="onTAFocus($event, 'strSQL')" v-model="node.props.strSQL" @input="save" class="prop-input code-input" rows="6" placeholder="输入SQL语句..." /></div>
          <div class="prop-row full">
            <label style="cursor:pointer;user-select:none" @click="showSqlVars = !showSqlVars">流程变量 {{ showSqlVars ? '▾' : '▸' }}</label>
            <div class="var-panel" v-show="showSqlVars">
              <div class="var-section">
                <div class="var-section-hd" @click="varFold.sys = !varFold.sys"><span class="var-arrow">{{ varFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ sysVariables.length }})</div>
                <div class="var-tags" v-show="varFold.sys">
                  <button v-for="v in sysVariables" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
              <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                <div class="var-section-hd" @click="toggleTableFold(tb.category)"><span class="var-arrow">{{ varFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                <div class="var-tags var-tags-scroll" v-show="varFold.tables[tb.category]">
                  <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
            </div>
          </div>
        </details>
      </template>

      <!-- ======= WebApi插件节点 type=43 ======= -->
      <template v-if="node.nodeType === 43">
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-info-circle"></i> 基本信息</summary>
          <div class="prop-row"><label>步骤名称</label><input v-model="node.props.stepName" @input="save" class="prop-input" /></div>
        </details>
        <details class="prop-group" open>
          <summary class="group-title"><i class="fas fa-globe"></i> WebApi插件设置</summary>
          <div class="prop-row"><label>API方式</label>
            <select v-model="node.props.dataSource" @change="save" class="prop-input">
              <option value="get">Get请求</option>
              <option value="post">Post请求</option>
            </select>
          </div>
          <div class="prop-row full"><label>API地址</label><textarea @focus="onTAFocus($event, 'strSQL')" v-model="node.props.strSQL" @input="save" class="prop-input" rows="4" placeholder="输入API地址..." /></div>
          <div class="prop-row full"><label>请求参数</label><textarea @focus="onTAFocus($event, 'repeatVar')" v-model="node.props.repeatVar" @input="save" class="prop-input code-input" rows="4" placeholder="JSON/URL参数..." /></div>
          <div class="prop-row full">
            <label style="cursor:pointer;user-select:none" @click="showApiVars = !showApiVars">流程变量 {{ showApiVars ? '▾' : '▸' }}</label>
            <div class="var-panel" v-show="showApiVars">
              <div class="var-section">
                <div class="var-section-hd" @click="varFold.sys = !varFold.sys"><span class="var-arrow">{{ varFold.sys ? '▾' : '▸' }}</span> 系统变量 ({{ sysVariables.length }})</div>
                <div class="var-tags" v-show="varFold.sys">
                  <button v-for="v in sysVariables" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
              <div class="var-section" v-for="tb in tableGroups" :key="tb.category">
                <div class="var-section-hd" @click="toggleTableFold(tb.category)"><span class="var-arrow">{{ varFold.tables[tb.category] ? '▾' : '▸' }}</span> {{ tb.category }} ({{ tb.items.length }})</div>
                <div class="var-tags var-tags-scroll" v-show="varFold.tables[tb.category]">
                  <button v-for="v in tb.items" :key="v.value" class="var-tag" @click="insertVar(v.value)" :title="v.desc">{{ v.label }}</button>
                </div>
              </div>
            </div>
          </div>
        </details>
      </template>

      <!-- 删除 -->
      <div class="node-delete-area">
        <button class="btn-delete-node" @click="$emit('delete', node.id)"><i class="fas fa-trash-alt"></i> 删除此节点</button>
      </div>
    </div>
    <PersonSelector :visible="psVisible" :source-type="psSourceType" @close="psVisible = false" @selected="onPersonSelected" />
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import PersonSelector from './PersonSelector.vue'
import ParticipantEditor from './ParticipantEditor.vue'
import SubFlowConfigPanel from './SubFlowConfigPanel.vue'
import { getFormsByFlow } from '../../../api/form'
import { getDataSources, getFormFields } from '../../../api/system'

/** 人员选择器状态 */
const psVisible = ref(false)
const psSourceType = ref('user')
/** 当前正在编辑的条目引用（handler/cc/receiver 数组中的某个元素） */
let psTarget = null
function openPersonSelector(target, sourceType) {
  psTarget = target; psSourceType.value = sourceType || 'user'; psVisible.value = true
}
function onPersonSelected(result) {
  if (!psTarget) return
  if (result.type === 'user') { psTarget.userCode = result.code; psTarget.userName = result.name }
  else if (result.type === 'org') { psTarget.orgCode = result.code; psTarget.orgName = result.name }
  else if (result.type === 'role') { psTarget.roleCode = result.code; psTarget.roleName = result.name }
  psVisible.value = false; save()
}

const props = defineProps({
  node: { type: Object, default: null },
  nodes: { type: Array, default: () => [] },
  edges: { type: Array, default: () => [] }
})
const emit = defineEmits(['update', 'delete', 'close', 'fieldsLoaded'])

const flowForms = ref([])

/** 参与者编辑器使用的步骤下拉数据（来自当前流程图中所有节点） */
const handlerStepOptions = computed(() => {
  const list = (props.nodes && props.nodes.length) ? props.nodes : []
  return list.map(n => ({
    id: n.id,
    name: (n.props && n.props.stepName) || n.name || n.id
  }))
})
const dataSourceList = ref([])
const showSqlVars = ref(false)
const showApiVars = ref(false)
// 流程变量折叠状态：sys=系统变量, tables={tableName: bool}（true=折叠）
const varFold = reactive({ sys: false, tables: {} })
function toggleTableFold(tbName) {
  if (varFold.tables[tbName] === undefined) varFold.tables[tbName] = false
  varFold.tables[tbName] = !varFold.tables[tbName]
}
const formFieldGroups = ref([])

// 合流节点：查找上游所有分流节点（反向遍历图）
const ancestorSplits = computed(() => {
  if (!props.node || props.node.nodeType !== 5) return []
  const nodeArr = props.nodes && props.nodes.length ? props.nodes : []
  const edgeArr = props.edges && props.edges.length ? props.edges : []
  if (!nodeArr.length || !edgeArr.length) return []

  // 构建反向邻接：nodeId → [来源nodeId列表]
  const revAdj = {}
  for (const e of edgeArr) {
    if (!revAdj[e.to]) revAdj[e.to] = []
    revAdj[e.to].push(e.from)
  }

  const visited = new Set()
  const splits = []
  const queue = [props.node.id]
  visited.add(props.node.id)

  while (queue.length > 0) {
    const current = queue.shift()
    const predecessors = revAdj[current] || []
    for (const pred of predecessors) {
      if (visited.has(pred)) continue
      visited.add(pred)
      const predNode = nodeArr.find(n => n.id === pred)
      if (!predNode) continue
      if (predNode.nodeType === 4) {
        splits.push({ id: predNode.id, name: predNode.props?.stepName || predNode.name || predNode.id })
      }
      queue.push(pred)
    }
  }
  return splits
})

// 流程变量（分类，使用旧系统 [%Category(SubValue)%] 格式）
const flowVariables = computed(() => {
  const vars = [
    // 系统变量
    { key: 'SysFunction', label: '[%SysFunction(TaskId)%]', value: '[%SysFunction(TaskId)%]', category: '系统变量', desc: '当前任务ID' },
    { key: 'SysFunction', label: '[%SysFunction(FlowGuid)%]', value: '[%SysFunction(FlowGuid)%]', category: '系统变量', desc: '流程GUID' },
    { key: 'SysFunction', label: '[%SysFunction(FlowName)%]', value: '[%SysFunction(FlowName)%]', category: '系统变量', desc: '流程名称' },
  ]
  // 表单字段
  for (const g of formFieldGroups.value) {
    for (const col of g.columns) {
      const fieldExpr = `FormDataSet(${g.tableName}.${col.columnName})`
      vars.push({
        key: 'FormDataSet',
        label: `[%${fieldExpr}%]`,
        value: `[%${fieldExpr}%]`,
        category: `表单字段-${g.tableName}`,
        desc: `${col.columnName} (${col.dataType})`
      })
    }
  }
  return vars
})

// 按分类分组
const groupedVariables = computed(() => {
  const map = {}
  for (const v of flowVariables.value) {
    if (!map[v.category]) map[v.category] = []
    map[v.category].push(v)
  }
  return Object.keys(map).map(cat => ({ category: cat, items: map[cat] }))
})

// 分离系统变量和表单字段分组（用于折叠面板）
const sysVariables = computed(() => {
  const g = groupedVariables.value.find(g => g.category === '系统变量')
  return g ? g.items : []
})
const tableGroups = computed(() => {
  return groupedVariables.value.filter(g => g.category !== '系统变量')
})

onMounted(async () => {
  const p = window.currentEditingProcess
  if (p?.guid) {
    try {
      const res = await getFormsByFlow(p.guid)
      const list = res?.data ?? res?.Data ?? []
      flowForms.value = Array.isArray(list) ? list.map(f => ({
        guid: f.guid ?? f.Guid ?? '',
        name: f.name ?? f.Name ?? f.formName ?? f.FormName ?? ''
      })) : []
    } catch (e) { console.error('Load flow forms error:', e) }
  }
  console.log('[NodeProperties] mounted, node:', props.node?.id, 'type:', props.node?.nodeType, 'customNotifyList:', props.node?.props?.customNotifyList, 'eventList:', props.node?.props?.eventList, 'ccList:', props.node?.props?.ccList)
  // 加载数据源列表
  try {
    const dsRes = await getDataSources()
    const dsList = dsRes?.data ?? dsRes?.Data ?? []
    dataSourceList.value = Array.isArray(dsList) ? dsList.map(d => (typeof d === 'string' ? d : (d.name ?? d.Name ?? d.key ?? d.Key ?? ''))).filter(Boolean) : []
  } catch (e) { console.error('Load data sources error:', e) }
  // 加载表单字段（用于流程变量）
  if (p?.guid) {
    try {
      const ffRes = await getFormFields(p.guid)
      const ffData = ffRes?.data ?? ffRes?.Data ?? []
      formFieldGroups.value = Array.isArray(ffData) ? ffData.map(g => ({
        tableName: g.tableName ?? g.TableName ?? '',
        columns: (g.columns ?? g.Columns ?? []).map(c => ({
          columnName: c.columnName ?? c.ColumnName ?? '',
          dataType: c.dataType ?? c.DataType ?? ''
        }))
      })) : []
      emit('fieldsLoaded', formFieldGroups.value)
    } catch (e) { console.error('Load form fields error:', e) }
  }
})

/** 追踪当前活跃的 textarea（用于变量插入） */
const activeTA = reactive({ el: null, context: null, idx: null })
function onTAFocus(e, context, idx) {
  activeTA.el = e.target
  activeTA.context = context
  activeTA.idx = idx ?? null
}
/** 将流程变量插入到当前活跃 textarea 的光标位置 */
function insertVar(varValue) {
  const el = activeTA.el
  if (!el) return
  const start = el.selectionStart
  const end = el.selectionEnd
  if (activeTA.context === 'event') {
    const events = ensureEventList()
    events[activeTA.idx].code = events[activeTA.idx].code.substring(0, start) + varValue + events[activeTA.idx].code.substring(end)
  } else {
    const key = activeTA.context
    const val = props.node.props[key] || ''
    props.node.props[key] = val.substring(0, start) + varValue + val.substring(end)
  }
  requestAnimationFrame(() => {
    el.focus()
    el.selectionStart = el.selectionEnd = start + varValue.length
  })
  save()
}

// ---- 文件上传 ----
const fileInput = ref(null)
const fileInput2 = ref(null)

function triggerFileSelect() {
  const el = fileInput.value || fileInput2.value
  if (el) el.click()
}

function onFileSelect(e) {
  const file = e.target.files?.[0]
  if (!file || !props.node) return
  props.node.props.operateDoc = file.name
  props.node.props.operateDocName = file.name
  props.node.props._operateDocFile = file
  save()
}

function save() {
  // 条件节点：自动根据可视化规则生成表达式
  if (props.node?.nodeType === 3) {
    updateCondFromCodeSilent()
    updateInitFromCodeSilent()
  }
  emit('update')
}

function setNodeProp(key, value) {
  if (props.node) props.node.props[key] = value
}

// ---- 任务操作权限 (14位: 取回/撤回/删除/公开/委托/调度/加签/询问/暂停/拒绝/退回/批处理/直送/传阅) ----
const approvelPermNames = ['取回','撤回','删除','公开','委托','调度','加签','询问','暂停','拒绝','退回','批处理','直送','传阅']
function ensureApprovelPerm() {
  if (!props.node) return '00000000000000'
  if (!props.node.props.approvelTaskPermit) props.node.props.approvelTaskPermit = '00000000000000'
  return props.node.props.approvelTaskPermit
}
function approvelPermChecked(i) { return ensureApprovelPerm()[i] === '1' }
function approvelPermToggle(i) {
  const arr = ensureApprovelPerm().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.approvelTaskPermit = arr.join('')
  save()
}
function approvelPermToggleAll() {
  const allSet = ensureApprovelPerm().split('').every(c => c === '1')
  props.node.props.approvelTaskPermit = allSet ? '00000000000000' : '11111111111111'
  save()
}

// ---- 附件权限 (3位) ----
function ensureAtt() {
  if (!props.node) return '000'
  if (!props.node.props.attachmentPerm) props.node.props.attachmentPerm = '000'
  return props.node.props.attachmentPerm
}
function attChecked(i) { return ensureAtt()[i] === '1' }
function attToggle(i) {
  const arr = ensureAtt().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.attachmentPerm = arr.join('')
  save()
}

// ---- 任务通知 (3位: 撤回/拒绝/退回) ----
function ensureNotify() {
  if (!props.node) return '000'
  if (!props.node.props.taskNotify) props.node.props.taskNotify = '000'
  return props.node.props.taskNotify
}
function notifyChecked(i) { return ensureNotify()[i] === '1' }
function notifyToggle(i) {
  const arr = ensureNotify().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.taskNotify = arr.join('')
  save()
}

// ---- 通知渠道 (3位: Mail/钉钉/微信) ----
const channelKeys = ['mail', 'dingtalk', 'wecom']
function ensureNotifyChannel() {
  if (!props.node) return '000'
  if (!props.node.props.notifyChannels) props.node.props.notifyChannels = '000'
  return props.node.props.notifyChannels
}
function notifyChannelChecked(ch) {
  const idx = channelKeys.indexOf(ch)
  return idx >= 0 && ensureNotifyChannel()[idx] === '1'
}
function notifyChannelToggle(ch) {
  const idx = channelKeys.indexOf(ch)
  if (idx < 0) return
  const arr = ensureNotifyChannel().split('')
  arr[idx] = arr[idx] === '1' ? '0' : '1'
  props.node.props.notifyChannels = arr.join('')
  save()
}

// ---- 同意规则 (4位) ----
function ensureAgreeRule() {
  if (!props.node) return '0000'
  if (!props.node.props.agreerule) props.node.props.agreerule = '0000'
  return props.node.props.agreerule
}
function agreeRuleChecked(i) { return ensureAgreeRule()[i] === '1' }
function agreeRuleToggle(i) {
  const arr = ensureAgreeRule().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.agreerule = arr.join('')
  save()
}

// ---- 条件类型 (4位: 表单字段/SQL/过程函数/发起人) ----
function ensureCondType() {
  if (!props.node) return '0000'
  if (!props.node.props.conditionType) props.node.props.conditionType = '0000'
  return props.node.props.conditionType
}
function condTypeChecked(i) { return ensureCondType()[i] === '1' }
function condTypeToggle(i) {
  const arr = ensureCondType().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.conditionType = arr.join('')
  save()
}

// ---- 条件节点：可视化条件构建器 ----
const showCondSqlVars = ref(false)

/** 表单字段条件规则列表 */
function ensureCondRules() {
  if (!props.node || props.node.nodeType !== 3) return []
  if (!Array.isArray(props.node.props.conditionRules)) props.node.props.conditionRules = []
  return props.node.props.conditionRules
}
function addCondRule() {
  ensureCondRules().push({ tableName: '', fieldName: '', operator: '=', value: '', logic: 'AND' })
  save()
}
function removeCondRule(idx) {
  ensureCondRules().splice(idx, 1)
  updateCondFromCode()
  save()
}
function onCondTableChange(rule) { rule.fieldName = ''; updateCondFromCode(); save() }

/** 发起人条件规则列表 */
function ensureInitRules() {
  if (!props.node || props.node.nodeType !== 3) return []
  if (!Array.isArray(props.node.props.initiatorRules)) props.node.props.initiatorRules = []
  return props.node.props.initiatorRules
}
function addInitRule() {
  ensureInitRules().push({ field: '', operator: '=', value: '', logic: 'AND' })
  save()
}
function removeInitRule(idx) {
  ensureInitRules().splice(idx, 1)
  updateInitFromCode()
  save()
}

/** 根据规则自动生成 fromCode 表达式（不触发 save） */
function updateCondFromCodeSilent() {
  const rules = ensureCondRules()
  props.node.props.fromCode = rules.filter(r => r.tableName && r.fieldName && r.operator)
    .map((r, i) => {
      let expr = `[${r.tableName}].[${r.fieldName}] ${r.operator}`
      if (!isNullOp(r.operator)) expr += ` '${r.value}'`
      return (i > 0 ? ` ${r.logic} ` : '') + expr
    }).join('')
}
function updateCondFromCode() { updateCondFromCodeSilent(); save() }

/** 根据规则自动生成 initiatorCode 表达式（不触发 save） */
function updateInitFromCodeSilent() {
  const rules = ensureInitRules()
  props.node.props.initiatorCode = rules.filter(r => r.field && r.operator)
    .map((r, i) => {
      let expr = `[发起人].[${r.field}] ${r.operator}`
      if (!isNullOp(r.operator)) expr += ` '${r.value}'`
      return (i > 0 ? ` ${r.logic} ` : '') + expr
    }).join('')
}
function updateInitFromCode() { updateInitFromCodeSilent(); save() }

/** 运算符列表（表单字段） */
const condOperators = [
  { value: '=', label: '=' }, { value: '!=', label: '!=' }, { value: '>', label: '>' },
  { value: '<', label: '<' }, { value: '>=', label: '>=' }, { value: '<=', label: '<=' },
  { value: 'LIKE', label: 'LIKE' }, { value: 'IN', label: 'IN' }, { value: 'NOT IN', label: 'NOT IN' },
  { value: 'IS NULL', label: 'IS NULL' }, { value: 'IS NOT NULL', label: 'IS NOT NULL' }
]
/** 运算符列表（发起人） */
const initOperators = [
  { value: '=', label: '=' }, { value: '!=', label: '!=' }, { value: 'LIKE', label: 'LIKE' }, { value: 'IN', label: 'IN' }
]
function isNullOp(op) { return op === 'IS NULL' || op === 'IS NOT NULL' }

/** 发起人信息字段选项 */
const initiatorFieldOptions = [
  { value: 'Department', label: '所属部门' }, { value: 'Role', label: '角色' },
  { value: 'Account', label: '用户账号' }, { value: 'UserName', label: '用户姓名' },
  { value: 'Position', label: '职位' }, { value: 'Company', label: '公司' }
]

/** 表单主表选项（从 tableGroups computed 获取） */
const tableGroupOptions = computed(() => {
  return tableGroups.value.map(g => ({ name: g.category, columns: g.items }))
})

/** 获取指定主表的字段列表 */
function getCondFields(tableName) {
  const tb = tableGroupOptions.value.find(t => t.name === tableName)
  if (!tb) return []
  return tb.columns.map(c => ({ value: c.value.split('.').pop(), label: c.label }))
}

/** 标准化人员条目：兼容旧格式，确保 relation、sourceType 字段存在 */
function normalizePersonItem(item) {
  if (!item) return
  if (!item.relation) item.relation = { enabled: false, type: '', positionName: '', rankLevel: 1, skipCount: 1 }
  if (!item.sourceType) {
    // 旧格式 { type, name, code } → 新格式
    const t = item.type || 'user'
    item.sourceType = t
    if (t === 'user') { item.userCode = item.code || ''; item.userName = item.name || '' }
    else if (t === 'org') { item.orgCode = item.code || ''; item.orgName = item.name || '' }
    else if (t === 'role') { item.roleCode = item.code || ''; item.roleName = item.name || '' }
    else if (t === 'field') { item.fieldName = item.name || '' }
  }
}

// ---- 处理人 ----
function ensureHandlers() {
  if (!props.node || (props.node.nodeType !== 1)) return []
  if (!Array.isArray(props.node.props.handlers)) props.node.props.handlers = []
  props.node.props.handlers.forEach(normalizePersonItem)
  return props.node.props.handlers
}
function addHandler() {
  ensureHandlers().push({
    sourceType: 'user', userCode: '', userName: '', orgCode: '', orgName: '',
    orgSubType: 'leader', orgRoleGuid: '', orgLeader: '',
    roleCode: '', roleName: '', includeSubRole: '0',
    stepNodeId: '', stepName: '', fieldName: '',
    leaderPosition: '', includeSubLeader: '0', includeSubMember: '0',
    customText: '',
    relation: { enabled: false, includeSuperior: false, byRank: false, type: 'direct_leader', positionName: '', rankLevel: 1, skipCount: 1 },
    showName: ''
  })
  save()
}
function removeHandler(idx) {
  ensureHandlers().splice(idx, 1)
  save()
}
const sourceTypeLabel = (t) => ({ submitter: '提交人', user: '指定用户', org: '指定组织', role: '指定角色', step: '某步处理人', field: '表单字段' }[t] || t)
// ---- 抄送人 ----
function ensureCCList() {
  if (!props.node || (props.node.nodeType !== 0 && props.node.nodeType !== 1)) return []
  if (!Array.isArray(props.node.props.ccList)) props.node.props.ccList = []
  props.node.props.ccList.forEach(normalizePersonItem)
  return props.node.props.ccList
}
function addCC() {
  ensureCCList().push({
    sourceType: 'user', userCode: '', userName: '', orgCode: '', orgName: '',
    orgSubType: 'leader', orgRoleGuid: '', orgLeader: '',
    roleCode: '', roleName: '', includeSubRole: '0',
    stepNodeId: '', stepName: '', fieldName: '',
    leaderPosition: '', includeSubLeader: '0', includeSubMember: '0',
    customText: '',
    relation: { enabled: false, includeSuperior: false, byRank: false, type: 'direct_leader', positionName: '', rankLevel: 1, skipCount: 1 },
    showName: ''
  })
  save()
}
function removeCC(idx) {
  ensureCCList().splice(idx, 1)
  save()
}

// ---- 触发事件 ----
function ensureEventList() {
  if (!props.node || (props.node.nodeType !== 0 && props.node.nodeType !== 1)) return []
  if (!Array.isArray(props.node.props.eventList)) props.node.props.eventList = []
  return props.node.props.eventList
}
function toggleEventVars(idx) {
  const events = ensureEventList()
  events[idx]._showVars = !events[idx]._showVars
}
function addEvent() {
  const defTrigger = props.node.nodeType === 0 ? 'afterSubmit' : 'afterAgree'
  ensureEventList().push({ trigger: defTrigger, name: '', code: '', executeType: 'SQL', dataSource: 'Default', _showVars: false })
  save()
}
function removeEvent(idx) {
  ensureEventList().splice(idx, 1)
  save()
}

// ---- 自定义通知 (支持开始节点0、审批节点1、邮件节点6、结束节点8) ----
function ensureCustomNotifyList() {
  if (!props.node || ![0, 1, 6, 8].includes(props.node.nodeType)) return []
  if (!Array.isArray(props.node.props.customNotifyList)) props.node.props.customNotifyList = []
  return props.node.props.customNotifyList
}
function addCustomNotify() {
  if (props.node && (props.node.nodeType === 6 || props.node.nodeType === 8)) {
    ensureCustomNotifyList().push({ notifyType: 'mail', msgName: '新任务通知', title: '', content: '', _showVars: false })
  } else {
    ensureCustomNotifyList().push({
      notifyType: 'mail', triggerOn: 'pending', title: '', content: '',
      sourceType: 'submitter', userCode: '', userName: '', orgCode: '', orgName: '',
      orgSubType: 'leader', orgRoleGuid: '', orgLeader: '',
      roleCode: '', roleName: '', includeSubRole: '0',
      stepNodeId: '', stepName: '', fieldName: '',
      leaderPosition: '', includeSubLeader: '0', includeSubMember: '0',
      customText: '',
      relation: { enabled: false, includeSuperior: false, byRank: false, type: 'direct_leader', positionName: '', rankLevel: 1, skipCount: 1 }
    })
  }
  save()
}
function removeCustomNotify(idx) {
  ensureCustomNotifyList().splice(idx, 1)
  save()
}

// ---- 邮件节点通知渠道 (4位: Mail/QQ/钉钉/微信) ----
function ensureNotifyCh() {
  if (!props.node || props.node.nodeType !== 6) return '0000'
  let v = props.node.props.notifyChannels
  if (!v || v.length < 4) v = (v || '0000').padEnd(4, '0')
  props.node.props.notifyChannels = v
  return v
}
function notifyChChecked(i) { return ensureNotifyCh()[i] === '1' }
function notifyChToggle(i) {
  const arr = ensureNotifyCh().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.notifyChannels = arr.join('')
  save()
}

// ---- 邮件节点收件人 ----
function ensureReceiverList() {
  if (!props.node || props.node.nodeType !== 6) return []
  if (!Array.isArray(props.node.props.receiverList)) props.node.props.receiverList = []
  props.node.props.receiverList.forEach(normalizePersonItem)
  return props.node.props.receiverList
}
function addReceiver() {
  ensureReceiverList().push({
    sourceType: 'user', userCode: '', userName: '', orgCode: '', orgName: '',
    orgSubType: 'leader', orgRoleGuid: '', orgLeader: '',
    roleCode: '', roleName: '', includeSubRole: '0',
    stepNodeId: '', stepName: '', fieldName: '',
    leaderPosition: '', includeSubLeader: '0', includeSubMember: '0',
    customText: '',
    relation: { enabled: false, includeSuperior: false, byRank: false, type: 'direct_leader', positionName: '', rankLevel: 1, skipCount: 1 },
    showName: ''
  })
  save()
}
function removeReceiver(idx) {
  ensureReceiverList().splice(idx, 1)
  save()
}

// ---- 邮件节点自定义通知模版：编辑器工具栏 & 流程变量 ----
const notifyActiveTA = reactive({ idx: null })
function onNotifyTAFocus(idx) { notifyActiveTA.idx = idx }

function insertNotifyTag(tag, idx) {
  const list = ensureCustomNotifyList()
  if (!list[idx]) return
  const ta = document.querySelector(`[data-notify-ta="${idx}"]`)
  if (!ta) {
    // fallback: insert at end
    let html = ''
    if (tag.type === 'FONTSIZE') {
      const sizes = { '1': '12px', '3': '16px', '5': '20px' }
      html = `<span style="font-size:${sizes[tag.value] || '14px'}">内容</span>`
    } else if (tag.type === 'COLOR') {
      html = `<span style="color:${tag.value}">内容</span>`
    } else if (tag.type === 'B') {
      html = '<b>内容</b>'
    } else if (tag.type === 'I') {
      html = '<i>内容</i>'
    } else if (tag.type === 'TABLE') {
      html = '<table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse"><tr><td>列1</td><td>列2</td></tr><tr><td>数据1</td><td>数据2</td></tr></table>'
    }
    list[idx].content = (list[idx].content || '') + html
    save()
    return
  }
  const start = ta.selectionStart
  const end = ta.selectionEnd
  const selText = ta.value.substring(start, end) || '内容'
  let insertHtml = ''
  if (tag.type === 'FONTSIZE') {
    const sizes = { '1': '12px', '3': '16px', '5': '20px' }
    insertHtml = `<span style="font-size:${sizes[tag.value] || '14px'}">${selText}</span>`
  } else if (tag.type === 'COLOR') {
    insertHtml = `<span style="color:${tag.value}">${selText}</span>`
  } else if (tag.type === 'B') {
    insertHtml = `<b>${selText}</b>`
  } else if (tag.type === 'I') {
    insertHtml = `<i>${selText}</i>`
  } else if (tag.type === 'TABLE') {
    insertHtml = '<table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse"><tr><td>列1</td><td>列2</td></tr><tr><td>数据1</td><td>数据2</td></tr></table>'
  }
  list[idx].content = list[idx].content.substring(0, start) + insertHtml + list[idx].content.substring(end)
  save()
  requestAnimationFrame(() => {
    ta.focus()
    ta.selectionStart = ta.selectionEnd = start + insertHtml.length
  })
}

function toggleNotifyVars(idx) {
  const list = ensureCustomNotifyList()
  if (list[idx]) list[idx]._showVars = !list[idx]._showVars
}

/** 通知系统变量（更全面，含当前处理人/节点等） */
const notifySysVariables = computed(() => {
  return [
    { label: '当前处理人', value: '[%CurrentUser%]', desc: '当前任务处理人账号' },
    { label: '当前处理人姓名', value: '[%CurrentUserName%]', desc: '当前任务处理人姓名' },
    { label: '当前处理节点', value: '[%CurrentStep%]', desc: '当前处理节点名称' },
    { label: '发起人', value: '[%Initiator%]', desc: '流程发起人账号' },
    { label: '发起人姓名', value: '[%InitiatorName%]', desc: '流程发起人姓名' },
    { label: '发起人部门', value: '[%InitiatorDept%]', desc: '发起人所属部门' },
    { label: '流程名称', value: '[%FlowName%]', desc: '流程名称' },
    { label: '流程编号', value: '[%FlowSerialNum%]', desc: '流程流水号' },
    { label: '任务ID', value: '[%TaskId%]', desc: '当前任务ID' },
    { label: '提交时间', value: '[%SubmitTime%]', desc: '任务提交时间' },
    { label: '审批意见', value: '[%ApprovalComment%]', desc: '最近审批意见' },
    { label: '流程链接', value: '[%FlowUrl%]', desc: '流程访问链接' },
    { label: '当前日期', value: '[%CurrentDate%]', desc: '当前日期(yyyy-MM-dd)' },
    { label: '当前时间', value: '[%CurrentTime%]', desc: '当前时间' },
    { label: '公司名称', value: '[%Company%]', desc: '公司名称' },
    { label: '上一步处理人', value: '[%PreStepUser%]', desc: '上一步处理人' },
    { label: '上一步意见', value: '[%PreStepComment%]', desc: '上一步审批意见' },
    { label: '系统URL', value: '[%SystemUrl%]', desc: '系统访问根地址' }
  ]
})

const notifyVarFold = reactive({ sys: false, tables: {} })
function toggleNotifyTableFold(tbName) {
  if (notifyVarFold.tables[tbName] === undefined) notifyVarFold.tables[tbName] = false
  notifyVarFold.tables[tbName] = !notifyVarFold.tables[tbName]
}

function insertNotifyVar(idx, varValue) {
  const list = ensureCustomNotifyList()
  if (!list[idx]) return
  const ta = document.querySelector(`[data-notify-ta="${idx}"]`)
  const curContent = list[idx].content || ''
  if (ta) {
    const start = ta.selectionStart
    const end = ta.selectionEnd
    list[idx].content = curContent.substring(0, start) + varValue + curContent.substring(end)
    save()
    requestAnimationFrame(() => {
      ta.focus()
      ta.selectionStart = ta.selectionEnd = start + varValue.length
    })
  } else {
    list[idx].content = curContent + varValue
    save()
  }
}

// ---- 超时设置 ----
function getTimeoutField(key) {
  if (!props.node) return ''
  // Parse from stored timeoutDate format like "1&100", "2&date", "3&fieldname"
  const val = props.node.props.timeoutDate || ''
  if (key === 'timeoutType') {
    if (!val) return ''
    const parts = val.split('&')
    return parts[0] || ''
  }
  if (key === 'timeoutValue') {
    const parts = val.split('&')
    return parts[1] || ''
  }
  if (key === 'timeoutCalendarType') {
    const cal = props.node.props.timeoutCalendar || ''
    const parts = cal.split('&')
    return parts[0] || ''
  }
  if (key === 'timeoutCalendarId') {
    const cal = props.node.props.timeoutCalendar || ''
    const parts = cal.split('&')
    return parts[1] || ''
  }
  if (key === 'timeoutProcessType') {
    const proc = props.node.props.timeoutProcess || ''
    const parts = proc.split('&')
    return parts[0] || ''
  }
  if (key === 'timeoutTarget') {
    const proc = props.node.props.timeoutProcess || ''
    const parts = proc.split('&')
    return parts[1] || ''
  }
  return ''
}

// ---- 开始节点通知 (4位: Mail/QQ/钉钉/微信) ----
function ensureStartNotify() {
  if (!props.node || props.node.nodeType !== 0) return '0000'
  let v = props.node.props.notifyChannels
  if (!v || v.length < 4) v = (v || '000').padEnd(4, '0')
  return v
}
function startNotifyChecked(i) { return ensureStartNotify()[i] === '1' }
function startNotifyToggle(i) {
  const arr = ensureStartNotify().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.notifyChannels = arr.join('')
  save()
}

// ---- 附件全选 ----
function attCheckedAll(n) {
  if (!props.node) return false
  const v = props.node.props.attachmentPerm || '000'
  return v.substring(0, n).split('').every(c => c === '1')
}
function attToggleAll(n) {
  if (!props.node) return
  const v = props.node.props.attachmentPerm || '000'
  const allChecked = v.substring(0, n).split('').every(c => c === '1')
  const newVal = allChecked ? '0'.repeat(n) : '1'.repeat(n)
  const rest = (v.length > n) ? v.substring(n) : ''
  props.node.props.attachmentPerm = newVal + rest
  save()
}

// ---- 通用属性存取 ----
function ps(key, defaultValue) {
  if (!props.node) return defaultValue
  const val = props.node.props[key]
  return val !== undefined && val !== null && val !== '' ? val : defaultValue
}
function setPs(key, value) {
  if (!props.node) return
  props.node.props[key] = value
  save()
}

// ---- 合并连线配置 (开始节点) ----
function ensureMergerList() {
  if (!props.node || props.node.nodeType !== 0) return []
  if (!Array.isArray(props.node.props.mergerName)) {
    // convert old string format to arrays
    const mn = typeof props.node.props.mergerName === 'string' && props.node.props.mergerName ? [props.node.props.mergerName] : []
    const ml = typeof props.node.props.mergerLinkId === 'string' && props.node.props.mergerLinkId ? [props.node.props.mergerLinkId] : []
    const mn2 = typeof props.node.props.mergerLinkName === 'string' && props.node.props.mergerLinkName ? [props.node.props.mergerLinkName] : []
    const maxLen = Math.max(mn.length, ml.length, mn2.length, 0)
    const list = []
    for (let i = 0; i < maxLen; i++) {
      list.push({ name: mn[i] || '', linkId: ml[i] || '', linkName: mn2[i] || '' })
    }
    props.node.props.mergerName = list.map(l => l.name)
    props.node.props.mergerLinkId = list.map(l => l.linkId)
    props.node.props.mergerLinkName = list.map(l => l.linkName)
  }
  return props.node.props.mergerName.map((name, i) => ({
    name: name || '',
    linkId: (props.node.props.mergerLinkId || [])[i] || '',
    linkName: (props.node.props.mergerLinkName || [])[i] || ''
  }))
}
function addMergerItem() {
  if (!props.node) return
  if (!Array.isArray(props.node.props.mergerName)) { ensureMergerList() }
  props.node.props.mergerName.push('')
  props.node.props.mergerLinkId.push('')
  props.node.props.mergerLinkName.push('')
  save()
}
function removeMergerItem(idx) {
  if (!props.node) return
  props.node.props.mergerName.splice(idx, 1)
  props.node.props.mergerLinkId.splice(idx, 1)
  props.node.props.mergerLinkName.splice(idx, 1)
  save()
}

// ---- 开始节点任务操作权限 (10位) ----
function ensureStartPerm() {
  if (!props.node || props.node.nodeType !== 0) return '0000000000'
  let v = props.node.props.startTaskPermit
  if (!v || v.length < 10) v = (v || '0000000000').padEnd(10, '0')
  props.node.props.startTaskPermit = v
  return v
}
function startPermAllChecked() { return ensureStartPerm().split('').every(c => c === '1') }
function startPermToggleAll() {
  const arr = ensureStartPerm().split('')
  const allChecked = arr.every(c => c === '1')
  props.node.props.startTaskPermit = (allChecked ? '0' : '1').repeat(10)
  save()
}
function startPermChecked(i) { return ensureStartPerm()[i] === '1' }
function startPermToggle(i) {
  const arr = ensureStartPerm().split('')
  arr[i] = arr[i] === '1' ? '0' : '1'
  props.node.props.startTaskPermit = arr.join('')
  save()
}
</script>

<style scoped>
.node-props { width: 300px; background: #fff; border-left: 1px solid #e5e7eb; display: flex; flex-direction: column; height: 100%; overflow: hidden; font-size: 13px; }
.props-header { display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 1px solid #e5e7eb; background: #f9fafb; font-weight: 500; }
.props-close { border: none; background: none; font-size: 18px; cursor: pointer; color: #9ca3af; padding: 0 4px; line-height: 1; }
.props-close:hover { color: #374151; }
.props-body { flex: 1; overflow-y: auto; padding: 8px 0; }

/* 分组 */
.prop-group { border-bottom: 1px solid #f3f4f6; }
.prop-group[open] > .group-title { border-bottom: 1px solid #e5e7eb; }
.group-title { padding: 8px 14px; cursor: pointer; font-weight: 500; color: #374151; font-size: 12px; display: flex; align-items: center; gap: 6px; list-style: none; }
.group-title::-webkit-details-marker { display: none; }
.group-title i { width: 16px; text-align: center; color: #10b981; }

/* 属性行 */
.prop-row { display: flex; align-items: center; padding: 5px 14px; gap: 8px; }
.prop-row.full { flex-wrap: wrap; }
.prop-row label { flex: 0 0 70px; font-size: 12px; color: #6b7280; white-space: nowrap; }
.prop-row.full > label { flex: 0 0 100%; margin-bottom: 2px; }
.prop-input { flex: 1; border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 8px; font-size: 12px; outline: none; min-width: 0; }
.prop-input:focus { border-color: #10b981; }
.prop-input.sm { flex: 0 0 60px; }
.prop-input[readonly] { background: #f3f4f6; }
.prop-check { width: 16px; height: 16px; cursor: pointer; accent-color: #10b981; }

textarea.prop-input { resize: vertical; min-height: 60px; }

/* 复选框组 */
.cb-group { display: flex; flex-wrap: wrap; gap: 4px 8px; flex: 1; }
.cb-label { display: flex; align-items: center; gap: 3px; font-size: 12px; color: #374151; cursor: pointer; white-space: nowrap; }
.cb-label input[type="checkbox"] { accent-color: #10b981; }

/* Radio组 */
.radio-group { display: flex; flex-wrap: wrap; gap: 4px 12px; flex: 1; }
.radio-label { display: flex; align-items: center; gap: 3px; font-size: 12px; color: #374151; cursor: pointer; white-space: nowrap; }
.radio-label input[type="radio"] { accent-color: #10b981; }

/* 抄送人卡片 */
.cc-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 4px; padding: 6px 8px; margin: 4px 14px 8px; }
.cc-card-row { display: flex; gap: 6px; align-items: center; }
.cc-card-col { display: flex; flex-direction: column; gap: 2px; }
.cc-card-col label { font-size: 10px; color: #9ca3af; }
.cc-card-remove { border: none; background: none; color: #ef4444; cursor: pointer; font-size: 14px; padding: 0 4px; }
.cc-add-btn { margin: 0 14px 8px; padding: 4px 12px; border: 1px dashed #10b981; background: #ecfdf5; color: #059669; font-size: 12px; border-radius: 4px; cursor: pointer; }
.cc-add-btn:hover { background: #10b981; color: #fff; }

/* 事件卡片 */
.event-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 4px; padding: 6px 8px; margin: 4px 14px 8px; }
.event-card-row { display: flex; gap: 6px; align-items: center; }
.event-card-col { display: flex; flex-direction: column; gap: 2px; flex: 1; }
.event-card-col label { font-size: 10px; color: #9ca3af; }
.event-card-remove { border: none; background: none; color: #ef4444; cursor: pointer; font-size: 14px; padding: 0 4px; }
.event-add-btn { margin: 0 14px 8px; padding: 4px 12px; border: 1px dashed #10b981; background: #ecfdf5; color: #059669; font-size: 12px; border-radius: 4px; cursor: pointer; }
.event-add-btn:hover { background: #10b981; color: #fff; }

/* 处理人卡片 */
.handler-card {
  margin: 8px 14px 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, .04);
  overflow: hidden;
  transition: border-color .15s, box-shadow .15s;
}
.handler-card:hover {
  border-color: #a7f3d0;
  box-shadow: 0 2px 6px rgba(16, 185, 129, .08);
}
.handler-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: linear-gradient(90deg, #ecfdf5 0%, #f0fdfa 100%);
  border-bottom: 1px solid #e5e7eb;
}
.handler-card-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
}
.handler-card-title > i.fa-user-tag {
  color: #10b981;
  font-size: 12px;
}
.handler-tag {
  display: inline-block;
  padding: 1px 8px;
  background: #d1fae5;
  color: #047857;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.handler-target {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.handler-card-remove {
  border: none;
  background: transparent;
  color: #ef4444;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background .15s, color .15s;
  flex-shrink: 0;
}
.handler-card-remove:hover {
  background: #fee2e2;
  color: #b91c1c;
}
.handler-card-body {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.handler-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.handler-label {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
}
.handler-control {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  padding: 5px 8px;
  font-size: 12px;
  outline: none;
  background: #fff;
  color: #1f2937;
  transition: border-color .15s, box-shadow .15s;
  box-sizing: border-box;
}
.handler-control:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, .12);
}
.relation-field {
  margin-top: 2px;
  padding-top: 8px;
  border-top: 1px dashed #e5e7eb;
}
.relation-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 12px;
  color: #374151;
  user-select: none;
}
.relation-toggle input { margin: 0; cursor: pointer; }
.handler-add-btn {
  margin: 4px 14px 12px;
  padding: 7px 14px;
  border: 1px dashed #6ee7b7;
  background: linear-gradient(180deg, #f0fdf4 0%, #ecfdf5 100%);
  color: #059669;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  width: calc(100% - 28px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all .15s;
}
.handler-add-btn:hover {
  background: #10b981;
  color: #fff;
  border-color: #10b981;
  box-shadow: 0 2px 6px rgba(16, 185, 129, .25);
}

select.prop-input { cursor: pointer; }

/* 删除节点 */
.node-delete-area { padding: 10px 14px; border-top: 2px solid #fee2e2; background: #fef2f2; margin-top: 4px; }
.btn-delete-node { width: 100%; padding: 8px 0; border: 1px solid #fca5a5; border-radius: 6px; background: #fff; color: #dc2626; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: all 0.15s; }
.btn-delete-node:hover { background: #fecaca; border-color: #ef4444; color: #b91c1c; }

/* 文件上传 */
.file-upload-row { display: flex; align-items: center; gap: 6px; flex: 1; }
.file-input { display: none; }
.btn-upload { padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 4px; background: #fff; color: #374151; font-size: 12px; cursor: pointer; white-space: nowrap; }
.btn-upload:hover { background: #f3f4f6; border-color: #10b981; color: #059669; }

/* 人员选择器点击区域 */
.selected-name { flex: 1; display: flex; flex-direction: column; gap: 1px; padding: 4px 8px; border: 1px solid #d1d5db; border-radius: 4px; cursor: pointer; min-width: 0; background: #fff; transition: border-color .15s; overflow: hidden; }
.selected-name:hover { border-color: #10b981; background: #f0fdf4; }
.selected-name.placeholder { color: #9ca3af; font-style: italic; }
.sel-name-text { font-size: 13px; color: #1f2937; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sel-code-text { font-size: 11px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.file-name { font-size: 11px; color: #6b7280; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 120px; }

/* 流程变量标签 */
.var-panel { margin-top: 4px; }
.var-section { margin-bottom: 4px; }
.var-section-hd { font-size: 11px; color: #6b7280; cursor: pointer; user-select: none; padding: 3px 6px; background: #f3f4f6; border-radius: 4px; display: flex; align-items: center; gap: 2px; transition: background 0.15s; }
.var-section-hd:hover { background: #e5e7eb; color: #374151; }
.var-arrow { font-size: 10px; width: 12px; display: inline-block; text-align: center; }
.var-tags { display: flex; flex-wrap: wrap; gap: 4px; padding: 4px 2px; }
.var-tags-scroll { max-height: 120px; overflow-y: auto; }
.var-tag { display: inline-block; padding: 2px 8px; border: 1px solid #d1d5db; border-radius: 10px; background: #f9fafb; color: #374151; font-size: 11px; cursor: pointer; transition: all 0.15s; line-height: 1.5; }
.var-tag:hover { background: #10b981; border-color: #10b981; color: #fff; }

/* 抄送人行（保留旧类名兼容抄送人/触发事件/自定义通知区域的 .handler-value + .selected-name 组合） */
.handler-value { flex: 1; border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 8px; font-size: 12px; outline: none; min-width: 0; }
.handler-value:focus { border-color: #10b981; }
.handler-list { margin-bottom: 4px; }

/* 合并连线表格 */
.simple-table { width: 100%; border-collapse: collapse; font-size: 11px; }
.simple-table th, .simple-table td { padding: 3px 4px; border: 1px solid #e5e7eb; text-align: left; }
.simple-table th { background: #f9fafb; font-weight: 500; color: #6b7280; }
.table-remove-btn { border: none; background: none; color: #ef4444; cursor: pointer; font-size: 14px; padding: 0 2px; line-height: 1; }
.table-remove-btn:hover { color: #dc2626; }

/* 代码输入框 */
.code-input { font-family: 'Consolas', 'Courier New', monospace; font-size: 12px; line-height: 1.5; background: #fafbfc; }

/* 条件节点可视化条件构建器 */
.cond-rules { margin-bottom: 6px; }
.cond-rule-row { display: flex; align-items: center; gap: 6px; margin: 4px 0; }
.cond-logic { flex-shrink: 0; width: 48px; }
.cond-logic-sel { width: 100%; border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 2px; font-size: 12px; outline: none; color: #6b7280; font-weight: 600; background: #f9fafb; cursor: pointer; text-align: center; }
.cond-logic-sel:focus { border-color: #10b981; }
.cond-fields { display: flex; gap: 4px; align-items: center; flex: 1; min-width: 0; }
.cond-sel { border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 4px; font-size: 12px; outline: none; cursor: pointer; min-width: 0; flex: 1; background: #fff; }
.cond-sel:focus { border-color: #10b981; }
.cond-op { border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 2px; font-size: 11px; outline: none; cursor: pointer; width: 80px; flex-shrink: 0; background: #fff; font-family: monospace; }
.cond-op:focus { border-color: #10b981; }
.cond-val { border: 1px solid #d1d5db; border-radius: 4px; padding: 5px 6px; font-size: 12px; outline: none; min-width: 60px; flex: 1; }
.cond-val:focus { border-color: #10b981; }
.cond-rm { border: none; background: none; color: #ef4444; cursor: pointer; font-size: 16px; padding: 0 2px; line-height: 1; flex-shrink: 0; }
.cond-rm:hover { color: #dc2626; }

/* 编辑器工具栏（自定义通知模版） */
.editor-toolbar { display: flex; align-items: center; gap: 4px; flex: 1; margin-top: 2px; flex-wrap: wrap; }
.toolbar-fontsize { border: 1px solid #d1d5db; border-radius: 4px; padding: 3px 4px; font-size: 11px; outline: none; cursor: pointer; background: #fff; width: 52px; }
.toolbar-fontsize:focus { border-color: #10b981; }
.toolbar-btn { border: 1px solid #d1d5db; border-radius: 4px; padding: 3px 7px; font-size: 12px; cursor: pointer; background: #fff; color: #374151; line-height: 1; transition: all 0.15s; min-width: 26px; text-align: center; }
.toolbar-btn:hover { background: #f3f4f6; border-color: #10b981; color: #059669; }
</style>
